import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import {
  ClientPurchaseOrderType,
  ClientPurchaseOrderTypeService,
} from '@app/core/client/services/client-purchase-order-type.service';

@Component({
  selector: 'filter-client-purchase-order-type',
  templateUrl: './filter-client-purchase-order-type.component.html',
  styleUrls: ['./filter-client-purchase-order-type.component.scss'],
})
export class FilterClientPurchaseOrderTypeComponent implements OnInit {
  constructor(
    private cd :ChangeDetectorRef,
    private clientPurchaseOrderTypeService :ClientPurchaseOrderTypeService,
  ) {}

  @Input() value :string;
  @Input() label :string = 'Client purchase order types';
  @Output() changeType :EventEmitter<string> = new EventEmitter<string>();

  public isLoading :boolean = true;
  public clientPurchaseOrderTypes :ClientPurchaseOrderType[] = [];

  ngOnInit() :void {
    this.clientPurchaseOrderTypeService
      .get({ per_page: 100 })
      .subscribe(({ data }) => {
        this.isLoading = false;
        this.clientPurchaseOrderTypes = data;
        this.cd.detectChanges();
      });
  }

  onChange() {
    this.changeType.emit(this.value);
  }
}
